
	// init
	var componentList = require('../lib/componentList');
	var requires = require('../lib/config').getRequireContexts();
	const utils = require('../lib/utils');
	const appConfig = require('../lib/config').getConfig();


	/**
	 * this function is used to initialize all components which will be needed if they are present within the component tree or not
	 */
	componentList.init = function () {
		this.loadTemplate(['section']);
		this.loadTemplate(['base','error','debug']);
		this.loadTemplate(['base','error','debugButton']);
	};

	/**
	 * this function is used to load a template in client-side code.
	 * it returns false if the load process was not successful or was not necessary.
	 *
	 * @param   componentGroup      [] - componentGroup (for details have a closer look at load())
	 * @param   key      			string - options key corresponding to the given component group
	 * @returns {boolean}
	 */
	componentList.loadTemplate = function (componentGroup, key) {
		if(!key){
			key = this.buildKey(componentGroup);
		}

		if (key) {
			if(this.templatesLoaded[key] !== undefined) return this.templatesLoaded[key];
			try {
				this.templates[key] = requires.templates('./' + this.buildPath(componentGroup) + '.ejs');
				this.templatesLoaded[key] = true;
				return true;
			}
			catch (error) {
				this.templatesLoaded[key] = false;
				if(appConfig.debug.componentListDebugging) {
					console.log('loadTemplate error', error);
				}
			}
		}

		return false;
	};

	/**
	 * this function is used to load a component in client-side code.
	 * it returns false if the load process was not successful or was not necessary.
	 *
	 * @param   componentGroup  [] - componentGroup (for details have a closer look at load())
	 * @param   key      		string - options key corresponding to the given component group
	 * @returns {boolean}
	 */
	componentList.loadComponent = function (componentGroup, key) {
		if(!key){
			key = this.buildKey(componentGroup);
		}
		if (key) {
			if(this.componentsLoaded[key] !== undefined) return this.componentsLoaded[key];
			try {
				return (this.componentsLoaded[key] = this.loadExtendedComponent(componentGroup, requires.components('./' + this.buildPath(componentGroup) + '.js')));
			}
			catch (error) {
				this.componentsLoaded[key] = false;
				if(appConfig.debug.componentListDebugging) {
					console.log('loadComponent error', error);
				}
			}
		}

		return false;
	};

	/**
	 * this function is used to load styles in client-side code.
	 * it returns false if the load process was not successful or was not necessary.
	 *
	 * @param   componentGroup  [] - componentGroup (for details have a closer look at load())
	 * @param   key      		string - options key corresponding to the given component group
	 * @returns {boolean}
	 */
	componentList.loadStyle = function (componentGroup, key) {
		if(!key){
			key = this.buildKey(componentGroup);
		}
		if (key) {
			if(this.stylesLoaded[key] !== undefined) return this.stylesLoaded[key];

			try {
				requires.styles('./' + this.buildPath(componentGroup) + '.less');
				this.stylesLoaded[key] = true;
				return true;
			}
			catch (error) {
				this.stylesLoaded[key] = false;
				if(appConfig.debug.componentListDebugging){
					console.log('loadStyle error', error);
				}
			}
		}

		return false;
	};

	/**
	 * this function is used to prepare the list of hooks (triggers)
	 *
	 * @param extensionKey		String - component extension key
	 * @param component			{} - component
	 * @returns 				{} - list of prepared hooks
	 */
	componentList.prepareTriggers = function(extensionKey, component){
		var h, hookName, hooks = {};
		for(h in (this.components[extensionKey] || {}).hooks || []){
			hooks[h] = this.components[extensionKey].hooks[h];
		}
		for(hookName in component.hooks || []){
			h = String(hookName).replace(/^_/, '');

			// extend hook
			if(h !== hookName && hooks[h]){
				// prepare list if necessary
				if(!utils.isArray(hooks[h])){
					hooks[h] = [hooks[h]];
				}
				hooks[h].push(component.hooks[hookName]);
			}
			// replace hook
			else {
				hooks[h] = component.hooks[hookName];
			}
		}

		return hooks;
	};

	componentList.init();

	module.exports = componentList;